// HSegBar — Horizontal stacked segment bar.
// Professional alternative to doughnut charts: instantly readable at a glance.
import React from "react";
import { InfoTip } from "../components/InfoTip";

const DEFAULT_PALETTE = ["#10B981", "#3B82F6", "#F59E0B", "#EF4444", "#8B5CF6", "#06B6D4", "#6B4E3D", "#C2A97F"];

/**
 * Props:
 *  - segments: [{ label, value, color?, sub? }, ...]
 *  - showValuesInBar: boolean (show % inside bar segments if width allows)
 *  - title: optional title above the bar
 *  - testid: optional data-testid root
 */
export default function HSegBar({ segments = [], showValuesInBar = true, title, testid }) {
  const clean = segments.filter((s) => (s.value || 0) > 0);
  const total = clean.reduce((s, x) => s + (x.value || 0), 0);
  if (total === 0) {
    return (
      <div data-testid={testid}>
        {title && <div style={titleStyle}>{title}</div>}
        <div className="hseg" style={{ justifyContent: "center", alignItems: "center", color: "var(--muted)", fontSize: 12 }}>
          لا توجد بيانات
        </div>
      </div>
    );
  }

  return (
    <div data-testid={testid}>
      {title && <div style={titleStyle}>{title}</div>}
      <div className="hseg" role="img" aria-label={title || "توزيع"}>
        {clean.map((s, i) => {
          const pct = (s.value / total) * 100;
          const color = s.color || DEFAULT_PALETTE[i % DEFAULT_PALETTE.length];
          return (
            <div
              key={`${s.label}-${i}`}
              className="hseg-cell"
              data-testid={testid ? `${testid}-cell-${i}` : undefined}
              style={{ flex: `${pct} 0 0`, background: color }}
 
            ><InfoTip text={`${s.label}: ${s.value.toLocaleString("en-US")} (${pct.toFixed(1)}%)`} />
              {showValuesInBar && pct >= 7 ? `${pct.toFixed(0)}%` : ""}
            </div>
          );
        })}
      </div>
      <div className="hseg-legend" data-testid={testid ? `${testid}-legend` : undefined}>
        {clean.map((s, i) => {
          const pct = (s.value / total) * 100;
          const color = s.color || DEFAULT_PALETTE[i % DEFAULT_PALETTE.length];
          return (
            <div key={`${s.label}-${i}`}>
              <i style={{ background: color }} />
              <b>{s.label}</b>
              <span>· {s.value.toLocaleString("en-US")} ({pct.toFixed(1)}%){s.sub ? ` · ${s.sub}` : ""}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const titleStyle = {
  fontSize: 13, fontWeight: 700, color: "var(--brown-deep)", marginBottom: 6,
};
